<script>
	import { createEventDispatcher } from 'svelte';

	export let file;

	const dispatch = createEventDispatcher();

	let fileInput;

	function onFile(f) {
		let image = f.target.files[0];
		let reader = new FileReader();
		reader.readAsDataURL(image);
		reader.onload = evt => {
			file = evt.target.result;
		};

		dispatch("update");
	}

	function clearFile() {
		file = null;
		fileInput.value = null;
		dispatch("clear");
	}

</script>

<div class="file-input">
	<input type="file" name="image" id="image"
				accept=".jpg, .jpeg, .png" bind:this={fileInput}
				on:change={(e)=>onFile(e)}
	>
	<label class="btn-label" class:active={file} for="image">
		<img src="img/photo-plus.svg" alt="Choose File">
		{#if file}
			<span>Change Photo</span>
		{:else}
			<span>Choose Photo</span>
		{/if}
	</label>

	<button class="secondary" class:disabled={!file} on:click={clearFile}>
		<span>Clear</span>
	</button>
</div>

<style>
	div.file-input {
		font-family: Inter;
		position: relative;
		margin-bottom: 1.5rem;
		display: grid;
		grid-template-columns: 3fr minmax(6rem, 1fr);
		column-gap: 0.5rem;
	}

	input[type="file"] {
		position: absolute;
		width:0;
		height: 0;
		opacity: 0;
		z-index: -10;
	}
</style>
